/**
 * Shared "Requires / Reward" cost-vs-reward table (.cg) — the boxed two-column
 * layout first used on Misdeeds / Good Deeds, now reused across every action &
 * shop page so the player reads cost-vs-gain the same way everywhere.
 *
 * The CSS lives globally in styles/pages.css (.cg, .cg-col, .cg-head, .cg-row,
 * .cg-k, .cg-v, .cg-v.gain, .cg-v.warn). These helpers just assemble the markup.
 *
 *   cgTable([
 *     cgCol('Requires', [ cgRow('Crowns', '1,200'), cgRow('Level', '5+', 'warn') ]),
 *     cgCol('Reward',   [ cgRow('Strength', '+40', 'gain') ]),
 *   ])
 *
 * Values (`v`) are emitted as raw HTML so callers can pass a formatted number or
 * a nested span; escape any untrusted text (item names, etc.) with escapeHtml
 * before passing it in.
 */

export type CgTone = '' | 'gain' | 'warn';

/** One label→value line inside a column. */
export function cgRow(k: string, v: string, tone: CgTone = ''): string {
  const cls = tone ? `cg-v ${tone}` : 'cg-v';
  return `<div class="cg-row"><span class="cg-k">${k}</span><span class="${cls}">${v}</span></div>`;
}

/** One labelled box (e.g. "Requires" or "Reward"). `rows` are cgRow() strings. */
export function cgCol(head: string, rows: string[]): string {
  return `<div class="cg-col"><div class="cg-head">${head}</div>${rows.join('')}</div>`;
}

/**
 * Assemble the boxed table from 1 or 2 columns. One column renders full-width
 * (.cg-one); two columns sit side by side and stack on narrow screens.
 */
export function cgTable(cols: string[]): string {
  const cls = cols.length === 1 ? 'cg cg-one' : 'cg';
  return `<div class="${cls}">${cols.join('')}</div>`;
}
